import { MenuAcceleratorBadgeSvg } from 'features/menu/components/menu-accelerator-badge/menu-accelerator-badge-svg';
import { BonusType, BonusTypes } from 'features/menu/components/menu-accelerator-badge/types';
import { StyleSheet, Text, View } from 'react-native';

import { primitive, spacing } from 'styles/constants';

interface IMenuAcceleratorBadgePDP {
  bonusPoints: number;
  pointsMultiplier: number;
}

export const MenuAcceleratorBadgePDP = ({
  bonusPoints,
  pointsMultiplier,
}: IMenuAcceleratorBadgePDP) => {
  const bonusType: BonusType = bonusPoints ? BonusTypes.BONUS_POINTS : BonusTypes.POINTS_MULTIPLIER;
  const promotionMessage = `Get ${
    bonusType === BonusTypes.BONUS_POINTS ? `+${bonusPoints}` : `${pointsMultiplier}x`
  } Crowns`;

  return (
    <View style={styles.container}>
      <View style={styles.badge}>
        <MenuAcceleratorBadgeSvg />
        <Text>{promotionMessage}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing.$4,
  },
  badge: {
    flexDirection: 'row',
    backgroundColor: primitive.$meltyYellow,
    paddingHorizontal: spacing.$2,
    paddingVertical: spacing[spacing.$0_5],
    borderRadius: 4,
    alignItems: 'center',
  },
});
